import { Translation } from 'cng-common/features/translations'
import { Button } from 'core-components/library/button'
import { Tooltip } from 'core-components/library/tooltip'

import { MDF_ACTIVITIES_TRANSLATION_KEYS } from '../../../../../../../../configs/translations'

import styles from './SuggestionItem.module.scss'

const KEYS = MDF_ACTIVITIES_TRANSLATION_KEYS

interface ISuggestionItemProps {
  label: string
  matchPercent: number
  disabled?: boolean
  onClick: () => void
}

export const SuggestionItem = ({
  label,
  matchPercent,
  disabled,
  onClick,
}: ISuggestionItemProps) => {
  return (
    <Tooltip tipContent={() => <Translation text={KEYS.linkage.suggestionTooltip} span />}>
      <Button className={styles.suggestion} disabled={disabled} onClick={onClick}>
        <span>{label}</span>
        <span className={styles.suggestionMatch}> {matchPercent}%</span>
      </Button>
    </Tooltip>
  )
}

SuggestionItem.displayName = 'SuggestionItem'
